export function menu() {
  createDesktopMenu()
}

function createDesktopMenu() {
  let $tree = $('#Tree').clone();
  $tree.attr("id", "desktopTree");
  $('#MainSection').prepend($tree);
}